import React, { useMemo } from 'react'

import { RespondentsBadge } from 'common/builder/components/chart/FlowChart/components/Node/components/ContentNodeHeader/RespondentsBadge'
import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import { FlowChartContentNodeHeader } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNodeHeader'
import { FlowChartContentRespontents } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentRespontents'

import * as styles from './ContentNodeHeader.styles'

interface ContentNodeHeaderProps {
  header: FlowChartContentNodeHeader
  respondents: FlowChartContentRespontents | null
  showStats: boolean
}

export const ContentNodeHeader = ({ header, respondents, showStats }: ContentNodeHeaderProps) => {
  const {
    icon: { icon, size, color },
    additionalIcon,
    rightIcon,
  } = header

  const iconString = useMemo(() => convertToIconString(icon, { size, color }), [color, icon, size])
  const additionalIconString = useMemo(
    () =>
      additionalIcon
        ? convertToIconString(additionalIcon.icon, { size: additionalIcon.size })
        : null,
    [additionalIcon],
  )

  const rightIconString = useMemo(
    () =>
      rightIcon
        ? convertToIconString(rightIcon.icon, { size: rightIcon?.size, color: rightIcon?.color })
        : null,
    [rightIcon],
  )

  const hasRespondents = Boolean(respondents) && respondents !== null
  const hasSubtitle = Boolean(header.subtitle)

  return (
    <view style={styles.Wrapper}>
      <view style={styles.MainIconWrapper}>
        <sprite image={iconString} style={styles.MainIcon} />
        {Boolean(additionalIconString) && (
          <sprite image={additionalIconString} style={styles.AdditionalIcon} />
        )}
      </view>
      <view style={hasSubtitle ? styles.ContentColumn : styles.ContentColumn}>
        {hasSubtitle && <richtext style={styles.SubTitleStyle} text={header.subtitle} />}
        <richtext
          style={hasSubtitle ? styles.TitleWithSubTitleStyle : styles.TitleStyle}
          text={header.title}
        />
      </view>
      <view style={styles.FloatingRightBlock}>
        {showStats && hasRespondents && (
          <>
            <RespondentsBadge respondents={respondents} />
            {rightIconString && <view style={styles.RespondentsIconSpacer} />}
          </>
        )}
        {rightIconString && <sprite image={rightIconString} style={styles.RightIcon} />}
      </view>
    </view>
  )
}
